import { render } from "./ordentrabajo.vue?vue&type=template&id=505d55c0"
import script from "./ordentrabajo.vue?vue&type=script&lang=js"
export * from "./ordentrabajo.vue?vue&type=script&lang=js"

import "./ordentrabajo.vue?vue&type=style&index=0&id=505d55c0&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__